import { FC } from 'react';
import { Tabs } from 'antd';
import { TbBrandOauth, TbBrowserCheck, TbBrowserPlus, TbDevicesCog } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { OurDocsLink } from '@/shared';
import { PlatformAlert } from '@/shared/components/alerts';
import {
    PreferenceModalHeader,
    PreferenceModalSiderOption,
} from '@/shared/components/modals/PreferenceModalPrimitives';
import { SetStateMethod } from '@/types';

import InlineIconLabel from '../../components/InlineIconLabel';
import { OAuthApplicationModalView } from '../../types';

interface SiderProps {
    view: OAuthApplicationModalView;
    setView: SetStateMethod<OAuthApplicationModalView>;
}

const Sider: FC<SiderProps> = ({ view, setView }) => {
    const { token } = useAntDesignTheme();

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%',
                backgroundColor: token.colorBgBase,
            }}
        >
            <div>
                <PreferenceModalHeader description='Build secure workspace integrations.' title='OAuth Applications' />
                <Tabs
                    size='small'
                    activeKey={view}
                    onChange={(nextView) => setView(nextView as OAuthApplicationModalView)}
                    items={[
                        {
                            key: 'add',
                            label: <InlineIconLabel icon={<TbBrowserPlus />} label='Create' />,
                        },
                        {
                            key: 'manage',
                            label: <InlineIconLabel icon={<TbDevicesCog />} label='Manage' />,
                        },
                    ]}
                    tabBarStyle={{
                        marginBottom: '0.75rem',
                        padding: '0 1rem',
                    }}
                />
                <div style={{ padding: '0 1rem' }}>
                    <div style={{ marginBottom: '0.75rem' }}>
                        <small style={{ color: token.colorTextTertiary }}>
                            {view === 'add' ? 'Application Type' : 'Applications'}
                        </small>
                    </div>
                    {view === 'add' ? (
                        <PreferenceModalSiderOption active>
                            <TbBrandOauth />
                            Custom OAuth 2.0
                        </PreferenceModalSiderOption>
                    ) : (
                        <PreferenceModalSiderOption active>
                            <TbBrowserCheck />
                            All Applications
                        </PreferenceModalSiderOption>
                    )}
                </div>
            </div>
            <div style={{ padding: '1rem' }}>
                <PlatformAlert
                    title='Secure OAuth configuration'
                    status='info'
                    description={
                        <span>
                            OAuth applications use scoped access and exact redirect URIs. Learn more in <OurDocsLink />
                        </span>
                    }
                />
            </div>
        </div>
    );
};

export default Sider;
